import $ from 'jquery';
import { pushNewUrl, popInitialStatePopupVideo } from 'OK/VideoHistoryHelper';
import logger from 'OK/logger';
import { ajax, isElementPartiallyInViewport, updateBlockModelCallback } from 'OK/utils/utils';
import VideoHelper from 'OK/VideoHelper';
import StickyPlayer from 'OK/StickyPlayer';
import { myTrackerService } from 'OK/metrics/MyTrackerService';
import { AccessibleModal } from 'OK/AccessibleModal';
import { unescapeXml } from 'OK/utils/vanilla';
import { scrollTo } from 'OK/animations';

var BLOCK_ID = 'AutoplayLayerMovieRBlock',
    URL_INIT_COMMENTS = '/dk?cmd=AutoplayLayerCommentsRBlock',
    URL_PLAY_MOVIE = '/dk?cmd=' + BLOCK_ID,
    URL_POP_LAYER_VIDEO = '/dk?cmd=PopLayerVideo', // @see /res/video.js
    URL_GET_METADATA_BY_ID = '/dk?cmd=videoPlayerMetaById',
    PLAYER_ELEMENT_ID = 'VideoAutoplayPlayerE',
    $layerContainer = null,
    $videoRBlock = null,
    $closeOverlay = null,
    playerTimerIsPaused = false,
    isCommenting = false,
    baseUrl = null,
    baseUrlPrefix = '/video/',
    VP_LAYER = 'vp-layer',
    VP_AUTOPLAY_LAYER = 'video_auto_player',
    ASYNC_TASKS_ENABLED = false,
    bannerImage = [],
    bannerStub = [],
    vpLayerBackId = 'vpLayerBack',
    vpLayerForwardId = 'vpLayerForward',
    vpLayerBack = null,
    vpLayerForward = null,
    reactAPI;

/**
 * Активирует леер.
 */
function activate() {

    // В случае если есть залипший плеер, то скроем его
    if (StickyPlayer.isActive()) {
        StickyPlayer.updateView({
            reset: true
        });
    }

    OK.loader.use(['OKCustomJs'], function() {
        OK.Layers.registerWithoutAccessibility(VP_AUTOPLAY_LAYER, clickClose);
        OK.setNotificationState && OK.setNotificationState(true);
        OK.hideToolbarSuggestions && OK.hideToolbarSuggestions();
    });

    $layerContainer = $('#vp_cnt').on('click', function(e) {
        // запрещаем закрытие леера по клику на контейнер флешки
        e.stopPropagation();
    }).on('click', '.js-vp-layer_video', function() {
        var $element = $(this),
            data = $element.data('meta') || {};

        navigateToMovie(URL_PLAY_MOVIE, data, data['st.vpl.id'], false);

        return false;
    });

    $closeOverlay = $('#vp_w .media-layer_close_ovr');

    var visibilityCoefficient = $layerContainer.data('visiblepart') || 0.4,
        player;
    $('#vpl_close').on('click.vp', clickClose);
    $closeOverlay.on('click.vp', clickClose);
    $('#vpl_minimize').on('click.vp', clickMinimize);
    vpLayerBack = $('#' + vpLayerBackId);
    vpLayerForward = $('#' + vpLayerForwardId);

    vpLayerBack.on('click.vp', function(e) {
        handleArrowClick.call(this, e, false);
    });

    vpLayerForward.on('click.vp', function(e) {
        handleArrowClick.call(this, e, true);
    });

    $videoRBlock = $('#hook_Block_PopLayerVideo').show().removeClass('layer__disabled'); // делаем видимым...
    $videoRBlock.find('.layer_ovr').on('click.vp', clickClose);
    $layerContainer.on('click', '.js-scrollToComments', scrollToComments);

    var commentsContainer = $('#movie-comments');
    ASYNC_TASKS_ENABLED = commentsContainer.data('async-activation-enabled') == true;


    activateAutoplaySection();
    initAutoplay();

    $videoRBlock.find('.js-video-album-link').on('click.vp', function() {
        document.location.href = $(this).attr('href');
    });

    // добавим если надо расхлоп для описания
    initReveal();

    // загрузим комментарии
    activateComments(visibilityCoefficient);
    toggleCinemaMode(false, OK.VideoPlayer.storage.isCinemaModeEnabled());

    $('#vp_w').on(
        {
            'scroll': function () {
                player = player || document.getElementById(PLAYER_ELEMENT_ID);
                if (!player || !player.call) {
                    return;
                }
                var isInViewport = isElementPartiallyInViewport(player, visibilityCoefficient);
                if (!playerTimerIsPaused && !isInViewport) {
                    player.call('pauseNextMovieCallTimer');
                    playerTimerIsPaused = true;
                    logger.success('vpal', 'timer', 'pause');
                } else if (playerTimerIsPaused && isInViewport && !isCommenting) {
                    player.call('playNextMovieCallTimer');
                    playerTimerIsPaused = false;
                    logger.success('vpal', 'timer', 'unpause');
                }
            },
            'mousewheel wheel': function (e) {
                var delta = VideoHelper.extractScrollDelta(e, this, true);

                if (!delta || delta === 0) {
                    return false;
                }

                var $autoplayContainer = $('#vp_cnt'),
                    elemLeftOffset = $autoplayContainer.offset().left,
                    elemLeftBoundary = elemLeftOffset - $(window).scrollLeft(),
                    elemRightBoundary = elemLeftBoundary + $autoplayContainer[0].offsetWidth,
                    cursorLeft = e.originalEvent.clientX;

                if (cursorLeft < elemLeftBoundary || cursorLeft > elemRightBoundary) {
                    var $scrollContainer = $(this);
                    $scrollContainer.scrollTop($scrollContainer.scrollTop() + delta);
                }
            }
        });
    reactAPI = undefined;

    var bannerContainer = document.querySelectorAll('.js-banner-container');
    if (bannerContainer && bannerContainer.length !== 0) {
        for (var i = 0; i < bannerContainer.length; i++) {
            bannerImage[0] = bannerContainer[i].querySelector('.js-banner');
            bannerStub[0] = bannerContainer[i].querySelector('.js-banner-stub');
        }
    }
}

/**
 * @private
 */
function activateAutoplaySection() {
    var $vpAlbList = $('#vp_alb_list');
    if (!$vpAlbList.length) {
        return;
    }

    var $activeMovieCard = $vpAlbList.find('.js-vp-layer_video.__active');
    if (!$activeMovieCard.length) {
        return;
    }

    var vpAlbList = $vpAlbList.get(0),
        activeMovieCard = $activeMovieCard.get(0),
        bounds = vpAlbList.getBoundingClientRect(),
        elementBounds = activeMovieCard.getBoundingClientRect();
    vpAlbList.scrollTop = vpAlbList.scrollTop + (Math.max(elementBounds.top - bounds.top, 0));

    $vpAlbList.on('mousewheel wheel', function(e) {
        if (this.scrollTop == (this.scrollHeight - this.offsetHeight)) {
            if (VideoHelper.extractScrollDelta(e, this, false) >= 0) {
                return false;
            }
        }
    });
}

/**
 * @private
 */
function initReveal(){
    var $videoDescriptionWrapper = $layerContainer.find('.vp-layer-description'),
        $videoDescription = $videoDescriptionWrapper.find('.js-vp-layer-description'),
        $videoDescriptionText = $videoDescriptionWrapper.find('.js-vp-layer-description_tx'),
        $showMoreLink = $videoDescriptionWrapper.find('.js-vp-layer-description_more'),

        lineHeight = parseInt($videoDescriptionText.css('line-height')),
        maxLines = 3,
        countsOfLines = $videoDescriptionText.height() / lineHeight,
        needReveal = countsOfLines > maxLines;

    // если 4 строчки, то выводим без расхлопа
    if (countsOfLines == maxLines + 1) {
        $videoDescription.addClass('__full');
    } else if (needReveal) {
        // если больше 4, то выводим только 3 и расхлоп
        $showMoreLink.removeClass('invisible');
    }

    $showMoreLink.on('click', function(){
        $showMoreLink.addClass('invisible');
        $videoDescription.addClass('__full');
        logger.success('vpal', 'reveal');
    });

    // показываем описание только после всех вычислений
    $videoDescriptionWrapper.removeClass('hidden');
}

/**
 * @private
 */
function initAutoplay() {
    $videoRBlock.find('.vp-layer_video-list_h-ac').on('click.vp', function() {
        var $this = $(this),
            isActive = $this.hasClass('__active');

        $this.toggleClass('__active');
        OK.VideoPlayer.storage.setAutoplayEnabled(!isActive);
        logger.success('vpal.autoplay', 'autoplaySwitch', !isActive);
    }).toggleClass('__active', OK.VideoPlayer.storage.isAutoplayEnabled());
}

/**
 * Инициализирует блок комментариев.
 * @private
 */
function activateComments(visibilityCoefficient) {
    var $commentsContainer = $('#movie-comments'),
        subjectId = $commentsContainer.data('subjectid'),
        discussionType = $commentsContainer.data('discussiontype'),
        commentId = $commentsContainer.data('commentid'),
        needTrackComment = $commentsContainer.data('needTrackComment'),
        player;

    if (subjectId && discussionType) {
        var requestData = {'st.vpl.discType': discussionType, 'st.vpl.subjid': subjectId};
        if (commentId) {
            requestData['st.vpl.cid'] = commentId;
        }
        ajax({
            url: URL_INIT_COMMENTS,
            data: requestData
        }).done(function(data, status, xhr) {
            updateBlockModelCallback(data, status, xhr, ASYNC_TASKS_ENABLED);
            $layerContainer.find('.js-comments_add').on('commentForm.stateChanged', function(event, state, isEnabled) {
                if (state === '__active') {
                    player = player || document.getElementById(PLAYER_ELEMENT_ID);
                    if (!player || !player.call) {
                        return;
                    }
                    if (isEnabled) {
                        isCommenting = true;
                        if (!playerTimerIsPaused) {
                            player.call('pauseNextMovieCallTimer');
                            playerTimerIsPaused = true;
                            logger.success('vpal', 'timer', 'pauseComment');
                        }
                    } else if (!isEnabled) {
                        isCommenting = false;
                        if (playerTimerIsPaused && isElementPartiallyInViewport(player, visibilityCoefficient)) {
                            player.call('playNextMovieCallTimer');
                            playerTimerIsPaused = false;
                            logger.success('vpal', 'timer', 'unpauseComment');
                        }
                    }
                }
            });

            if (needTrackComment) {
                $layerContainer.find('.js-comments_add_form').on('submit', function (e) {
                    myTrackerService.trackCustomGoal('comment_in_sport_broadcast');
                });
            }
            AccessibleModal.registerModal(VP_AUTOPLAY_LAYER);
        });
    }
}

/**
 * Деактивирует леер.
 */
function deactivate() {
    $layerContainer.off('click');
    $closeOverlay.off('click.vp');
    $videoRBlock.find('.vp-layer_video-list_h-ac').off('.vp');
    $videoRBlock.find('.js-video-album-link').off('.vp');

    OK.loader.use(['OKCustomJs'], function() {
        OK.Layers.remove(VP_AUTOPLAY_LAYER);
        OK.setNotificationState && OK.setNotificationState(false);
    });
    $('#vp_w').off('scroll').off('mousewheel wheel');
    $('#vp_alb_list').off('mousewheel wheel');
    $layerContainer.find('.js-comments_add').off('commentForm.stateChanged');
    $('#js-videopins-container').off('click');
}

/**
 * Закрывает леер.
 */
function clickClose(e) {
    e && e.preventDefault();
    OK.loader.use(['OKCustomJs'], function() {
        OK.Layers.remove(VP_AUTOPLAY_LAYER);
    });
    OK.hookModel.setHookContent('PopLayerVideo', '', ASYNC_TASKS_ENABLED); // binded from GWT
    popInitialStatePopupVideo();

    showBanners();
}

function showBanners() {
    if (!bannerImage || bannerImage.length === 0) {
        return;
    }

    for (var i = 0; i < bannerImage.length; i++) {
        bannerImage[i] && bannerImage[i].classList.toggle('__hidden', false);
        bannerStub[i] && bannerStub[i].classList.toggle('__hidden', true);
    }
}

/**
 * Сворачивает леер в мини-плеер.
 * @param {Event} e
 */
function clickMinimize(e) {
    e.preventDefault();
    var minimizeUrl = this.getAttribute('data-url'),
        movieId = this.getAttribute('data-movie-id');
    ajax({
        url: minimizeUrl,
        data: {
            'st.vpl.ft': Math.floor(OK.VideoPlayer.storage.getMovieLastPlayingTime(movieId))
        }
    }).done(function (data, status, xhr) {
        updateBlockModelCallback(data, status, xhr, ASYNC_TASKS_ENABLED);
    });
    popInitialStatePopupVideo();
    showBanners();
}

/**
 * Обработчик клика по стрелкам след/пред видео
 * @param {Event} e
 * @param {boolean} isNext - true для следующего ролика, false для предыдущего
 */
function handleArrowClick(e, isNext) {
    e.preventDefault();

    var movieId = this.getAttribute('data-movie-id'),
        albumId = this.getAttribute('data-album-id'),
        autoplayType = this.getAttribute('data-autoplay-type');

    // дефолтный колбек передается через okHtml5Player
    var callback = (res) => {};

    if (isNext) {
        playNextMovie(movieId, albumId, autoplayType, null, callback, true);
    } else {
        playPreviousMovie(movieId, albumId, autoplayType, null, callback, true);
    }
}

/**
 * @private
 * @param {string} url
 * @param {{}} data
 * @param {string} movieId
 * @param {boolean} skipForHistory
 */
function navigateToMovie(url, data, movieId, skipForHistory) {
    var fetchType = data['st.vpl.vs'];
    if (fetchType === 'top' || fetchType === 'musicVideos' || fetchType === 'collage' || fetchType === 'playlistFromMovie') {
        var moviesIds = getMoviesIds();
        if (moviesIds && moviesIds.length) {
            data['st.vpl.vp'] = moviesIds;
        }
    } else if (fetchType === 'recommended_movie') {
        var alreadySeenSimilar = OK.VideoPlayer.storage.getAlreadySeenSimilar(20);
        if (alreadySeenSimilar.length > 0) {
            data['st.vpl.assm'] = alreadySeenSimilar.join(',');
        }
    }

    if (OK.getCurrentStateLink && (url === URL_PLAY_MOVIE || url === URL_POP_LAYER_VIDEO)) {
        var baseUrl = OK.getCurrentStateLink();
        url = baseUrl + (baseUrl.indexOf('?') === -1 ? '?' : '&') + url.substring("/dk?".length);
    }

    ajax({
        url: url,
        data: data
    }).done(updateBlockModelCallback).done(function() {
        if (!skipForHistory) {
            if (data['st.vpl.bu']) {
                pushNewUrl(data['st.vpl.bu'], false, 'popVideo');
            } else {
                if (data.hasOwnProperty('st.vpl.lv')) {
                    baseUrlPrefix = data['st.vpl.lv'] ? '/live/' : '/video/';
                }
                pushNewUrl(baseUrlPrefix + movieId, false, 'popVideo');
            }
        }
    });
}

/**
 * Обновляет леер проигрывания с задаными movieId и albumId
 * @param {string} albumId
 * @param {string} movieId
 * @param {string} autoplayType
 * @param {number} movieIndex
 */
function playMovie(movieId, albumId, autoplayType, movieIndex) {
    var data = {'st.vpl.id': movieId, 'st.vpl.na': 'on', 'st.vpl.vs': autoplayType, 'st.vpl.fe': 'on'};
    if (!autoplayType) {
        return;
    }
    switch (autoplayType) {
        case 'top':
        case 'recommended_movie':
        case 'musicVideos':
        case 'collage':
        case 'playlistFromMovie':
            break;
        case 'album':
            if (!albumId || !movieId) {
                return;
            }

            data['st.vpl.albumId'] = albumId;
            break;
        default:
            logger.success('vpal', 'fullscreenexit', autoplayType);
            return;
    }
    logger.success('vpal', 'fullscreenexit', autoplayType);
    navigateToMovie(URL_PLAY_MOVIE, data, movieId, false);
}

/**
 * @private
 */
function getMoviesIds() {
    var moviesIds = [];
    $('#vp_alb_list').find('.vp-layer_video').each(function() {
        moviesIds.push($(this).data('id'));
    });
    if (!moviesIds.length && reactAPI) {
        var playlist = reactAPI.getPlaylist();
        moviesIds = playlist.items.map(function (item) {
            return item.id;
        });
    }
    return moviesIds.join(',');
}

/**
 * Проигрывает следующий за переданным ролик в режиме автопросмотра
 * @param {string} movieId
 * @param {string} albumId
 * @param {string} autoplayType
 * @param {number | null} movieIndex
 * @param {function=} callback
 * @param {boolean=} isAuto
 */
function playNextMovie(movieId, albumId, autoplayType, movieIndex, callback, isAuto) {
    handlePlayMovie(movieId, albumId, autoplayType, movieIndex, callback, isAuto, true);
}

/**
 * Проигрывает предыдущий ролик
 * @param {string} movieId
 * @param {string} albumId
 * @param {string} autoplayType
 * @param {number | null} movieIndex
 * @param {function=} callback
 * @param {boolean=} isAuto
 */
function playPreviousMovie(movieId, albumId, autoplayType, movieIndex, callback, isAuto) {
    handlePlayMovie(movieId, albumId, autoplayType, movieIndex, callback, isAuto, false);
}

/**
 * Возвращает мета-информацию из карточки блока рекомендаций,
 * из <recommendation-block/>
 * @private
 * @param {object} item
 * @return {object}
 */
function getMeta(item) {
    return item && JSON.parse(unescapeXml(item.meta));
}

/**
 * Внутренняя функция для управления логикой проигрывания следующего или предыдущего ролика
 * @param {string} movieId
 * @param {string} albumId
 * @param {string} autoplayType
 * @param {number} movieIndex
 * @param {function=} callback
 * @param {boolean=} isAuto
 * @param {boolean} isNext - true для следующего ролика, false для предыдущего
 */
function handlePlayMovie(movieId, albumId, autoplayType, movieIndex, callback, isAuto, isNext) {
    function callCallback(result) {
        typeof callback === 'function' && callback(result);
    }

    if (!movieId || !autoplayType) {
        return callCallback(false);
    }

    function getMeta(item) {
        return item && JSON.parse(unescapeXml(item.meta));
    }

    var movies = reactAPI && reactAPI.getPlaylist().items;

    var firstMovie = movies && movies[0];
    var firstMovieMeta = getMeta(firstMovie);

    var lastMovie = movies && movies[movies.length - 1];
    var lastMovieMeta = getMeta(lastMovie);

    var isNeedPlayFirstItem = reactAPI && reactAPI.isNeedPlayFirstItem();
    var currentMovie = movies && movies.find(function(item) {
        return item.id === movieId;
    });

    if (currentMovie) {
        var currentMovieIdx = movies.indexOf(currentMovie);
        var targetMovie = isNext
            ? movies[currentMovieIdx + 1]
            : movies[currentMovieIdx - 1];
        var targetMovieMeta = getMeta(targetMovie);
    }

    var $movieLink = $('#nohook_album_movie_' + movieId),
        $targetMovieLink = isNext ? $movieLink.next() : $movieLink.prev(),
        data = {'st.vpl.na': 'on', 'st.vpl.vs': autoplayType, 'st.vpl.fs': 'on', 'st.vpl.ial': isAuto};

    function navigateForAutoplay(linkData) {
        logger.success('vpal.autoplay', isNext ? 'playNext' : 'playPrev', autoplayType);
        navigateToMovie(URL_PLAY_MOVIE, $.extend(data, linkData), linkData['st.vpl.id'], false);
        return callCallback(true);
    }

    switch (autoplayType) {
        // автопросмотр по топу
        case 'top':
        // автопросмотр по музыкальным клипам
        case 'musicVideos':
        // автопросмотр коллажа
        case 'collage':
        // автопросмотр по роликам, обозначенным "следующими" в исходном ролике
        case 'playlistFromMovie':
            var isCircular = $('#vp-sidebar').data('circular');

            if (reactAPI) {
                if (!currentMovie) {
                    if (isNeedPlayFirstItem) {
                        navigateForAutoplay(firstMovieMeta);
                    }
                    return callCallback(false);
                }

                if (targetMovie) {
                    // нашли ссылку - переходим по ней
                    navigateForAutoplay(targetMovieMeta);
                } else if (isCircular) {
                    // не нашли ссылку на след. ролик - значит мы в конце списка. В этом случае проигрываем список с самого начала
                    navigateForAutoplay(firstMovieMeta);
                } else {
                    callCallback(false);
                }
            } else {
                if (!$movieLink.length) {
                    return callCallback(false);
                }

                if ($targetMovieLink.length) {
                    // нашли ссылку - переходим по ней
                    navigateForAutoplay($targetMovieLink.data('meta'));
                } else if (isCircular) {
                    // не нашли ссылку на след. ролик - значит мы в конце списка. В этом случае проигрываем список с самого начала
                    navigateForAutoplay($('#vp_alb_list').find('.js-vp-layer_video').first().data('meta'));
                } else {
                    callCallback(false);
                }
            }
            break;
        // автопросмотр по альбомам
        case 'album':
            if (reactAPI) {
                if (!currentMovie) {
                    /* Когда перешли на канал, но в реках "Похожие" -> они подменяются при <2 видео на канале */
                    if (firstMovieMeta) {
                        navigateForAutoplay(firstMovieMeta);
                    }
                    return callCallback(false);
                }
            } else {
                if (!$movieLink.length) {
                    return callCallback(false);
                }
                if ($targetMovieLink.length) {
                    // нашли ссылку - переходим по ней
                    targetMovieMeta = $targetMovieLink.data('meta');
                }
            }
            // не нашли ссылку на след ролик, значит мы в конце/начале списка проигрывания. Начнем с самого начала/конца
            if (targetMovieMeta && targetMovie.id !== currentMovie.id) {
                // нашли ссылку - переходим по ней
                navigateForAutoplay(targetMovieMeta);
            } else {
                if (!isNext && lastMovie && lastMovieMeta) {
                    // стрелка "назад" и не нашли ссылку -> проигрываем последний ролик в списке
                    navigateForAutoplay(lastMovieMeta);
                } else {
                    // получаем id ролика, с которого нужно начать автопроигрывание по этому альбому и навигируемся на страничку проигрывания этого ролика
                    getNextMetadata(movieId, albumId, autoplayType, movieIndex, false, function (resp) {
                        if (resp && !resp.error && resp.movie && resp.movie.movieId) {
                            data['st.vpl.id'] = resp.movie.movieId;
                            data['st.vpl.albumId'] = albumId;
                            data['st.vpl.lv'] = resp.movie.isLive;
                            logger.success('vpal.autoplay', 'playNext', autoplayType);
                            navigateToMovie(URL_PLAY_MOVIE, data, resp.movie.movieId, false);
                            callCallback(true);
                        } else {
                            callCallback(false);
                        }
                    });
                }
            }
            break;
        // автопросмотр по рекомендация
        case 'recommended_movie':
            if (reactAPI) {
                if (!firstMovieMeta) {
                    return callCallback(false);
                }
            } else {
                $targetMovieLink = $('#nohook_recommended_movie');
                if (!$targetMovieLink.length) {
                    return callCallback(false);
                }
                firstMovieMeta = $targetMovieLink.data('meta');
            }
            firstMovieMeta['st._aid'] += '_auto';
            navigateForAutoplay(firstMovieMeta);
            break;
        case 'mallProductMovie':
            import('OK/MallProductVideoPortletEventBuses').then(m => m && m.default || m).then(function (MallProductVideoPortletEventBuses) {
                MallProductVideoPortletEventBuses.MALL_PLAY_NEXT_VIDEO.emit({
                    currentMovieId: movieId
                }, this);
            });
            break;
        case 'sameAuthor':
            if (reactAPI) {
                if (!currentMovie) {
                    /* Когда перешли на "Видео автора", но в реках "Похожие" -> они подменяются при <2 видео у автора */
                    if (firstMovieMeta) {
                        navigateForAutoplay(firstMovieMeta);
                    }
                    return callCallback(false);
                }
            } else {
                if (!$movieLink.length) {
                    return callCallback(false);
                }
                if ($targetMovieLink.length) {
                    // нашли ссылку - переходим по ней
                    targetMovieMeta = $targetMovieLink.data('meta');
                }
            }
            // не нашли ссылку на след ролик, значит мы в конце списка проигрывания. Начнем с самого начала
            if (targetMovieMeta) {
                // нашли ссылку - переходим по ней
                navigateForAutoplay(targetMovieMeta);
            } else {
                if (isNext && firstMovieMeta) {
                    // стрелка "вперед" и не нашли ссылку -> проигрываем первый ролик в списке
                    navigateForAutoplay(firstMovieMeta);
                } else if (lastMovie && lastMovieMeta) {
                    // стрелка "назад" и не нашли ссылку -> проигрываем последний ролик в списке
                    navigateForAutoplay(lastMovieMeta);
                } else {
                    callCallback(false);
                }
            }
            return;
    }
}

/**
 * Получим id видео, который необходимо проиграть следующим
 * @param autoplayType
 * @param currentMovieId
 * @return {string|null}
 */
function getNextMovieId(autoplayType, currentMovieId) {
    var movies = reactAPI && reactAPI.getPlaylist().items;

    var firstMovie = movies && movies[0];

    var isNeedPlayFirstItem = reactAPI && reactAPI.isNeedPlayFirstItem();
    var currentMovie = movies && movies.find(function(item) {
        return item.id === currentMovieId;
    });

    if (currentMovie) {
        var currentMovieIdx = movies.indexOf(currentMovie);
        var nextMovie = movies[currentMovieIdx + 1];
    }

    /**
     * @private
     * @param {object} data
     * @return {string | null}
     */
    function getMovieIdFromReact(data) {
        return data["id"] ? data["id"] : null;
    }

    switch (autoplayType) {
        // автопросмотр по топу
        case 'top':
        // автопросмотр по музыкальным клипам
        case 'musicVideos':
        // автопросмотр коллажа
        case 'collage':
        // автопросмотр по роликам, обозначенным "следующими" в исходном ролике
        case 'playlistFromMovie':
            var isCircular = $('#vp-sidebar').data('circular');
            if (!currentMovie && isNeedPlayFirstItem) {
                return getMovieIdFromReact(firstMovie);
            }
            if (nextMovie) {
                // нашли ссылку - переходим по ней
                return getMovieIdFromReact(nextMovie);
            } else if (isCircular && firstMovie) {
                // не нашли ссылку на след. ролик - значит мы в конце списка. В этом случае проигрываем список с самого начала
                return getMovieIdFromReact(firstMovie);
            }
            break;
        // автопросмотр по альбомам
        case 'album':
            if (!currentMovie) {
                /* Когда перешли на канал, но в реках "Похожие" -> они подменяются при <2 видео на канале */
                if (firstMovie) {
                    return getMovieIdFromReact(firstMovie);
                }
            }

            // не нашли ссылку на след ролик, значит мы в конце/начале списка проигрывания. Начнем с самого начала/конца
            if (nextMovie && nextMovie.id !== currentMovie.id) {
                // нашли ссылку - переходим по ней
                return getMovieIdFromReact(nextMovie);
            } else if (firstMovie) {
                return getMovieIdFromReact(firstMovie);
            }
            break;
        // автопросмотр по рекомендация
        case 'recommended_movie':
            if (firstMovie) {
                return getMovieIdFromReact(firstMovie);
            }
            break;
        case 'sameAuthor':
            if (!currentMovie) {
                /* Когда перешли на "Видео автора", но в реках "Похожие" -> они подменяются при <2 видео у автора */
                if (firstMovie) {
                    return getMovieIdFromReact(firstMovie);
                }
            }
            // не нашли ссылку на след ролик, значит мы в конце списка проигрывания. Начнем с самого начала
            if (nextMovie) {
                // нашли ссылку - переходим по ней
                return getMovieIdFromReact(nextMovie);
            }
            break;
        default:
            return null;
    }
}

/**
 * @private
 * Получим мета-данные о следующем видео для автопроигрывания,
 * чтобы отрисовать превью в видео-плеере
 * @param {string} movieId
 * @param {string} albumId
 * @param {string} autoplayType
 * @param {number} movieIndex
 * @param {boolean} isSmall
 * @param {function=} callback
 */
function getNextMetadata(movieId, albumId, autoplayType, movieIndex, isSmall, callback) {
    function sendRequestForNextMeta(data, callback, url) {
        ajax({
            url: url,
            data: data
        }).done(function(data) {
            if (typeof callback === 'function') {
                callback(data);
            }
        }).fail(function(jqXHR, textStatus) {
            callback({'error': textStatus});
        });
    }
    var nextMovieId = getNextMovieId(autoplayType, movieId);

    var data = {'st.vp.meta.mid': nextMovieId, 'st.vp.meta.in': 'on', 'st.vp.meta.vs': autoplayType};
    if (isSmall === true) {
        data['st.vp.meta.is'] = 'on';
    }

    if (nextMovieId) {
        switch (autoplayType) {
            // автопросмотр по топу
            case 'top':
            // автопросмотр по музыкальным клипам
            case 'musicVideos':
            // автопросмотр коллажа
            case 'collage':
            // автопросмотр по роликам, обозначенным "следующими" в исходном ролике
            case 'playlistFromMovie':
                data['vp'] = getMoviesIds();
                break;
            // автопросмотр по альбомам
            case 'album':
                if (!albumId || !movieId) {
                    return;
                }

                data['albumId'] = albumId;
                break;
            // автопросмотр по рекомендация
            case 'recommended_movie':
            case 'sameAuthor':
                break;
            case 'mallProductMovie':
                import('OK/MallProductVideoPortletEventBuses').then(m => m && m.default || m).then(function (MallProductVideoPortletEventBuses) {
                    MallProductVideoPortletEventBuses.MALL_GET_NEXT_VIDEO_METADATA.emit({
                        currentMovieId: movieId,
                        onGetMetaDataCallback: callback
                    }, this);
                });
                return;
            default:
                logger.success('vpal', 'nextmetadata', autoplayType + (isSmall ? '_small' : '_full'));
                return;
        }

        logger.success('vpal', 'nextmetadata', autoplayType + (isSmall ? '_small' : '_full'));
        sendRequestForNextMeta(data, callback, URL_GET_METADATA_BY_ID);
    }
}

/**
 * @param {boolean} animation
 * @param {boolean=} value
 * @return {boolean}
 */
function toggleCinemaMode(animation, value) {
    var $videoLayer = $layerContainer.find('.vp-layer'),
        redesign2023 = $layerContainer.data('version') === 2023,
        $scrollingContainer = $('#vp_w'),
        scrollingContainer = $scrollingContainer[0],
        cinemaModeEnabled = $videoLayer.hasClass('__cinema');

    if (animation) {
        $videoLayer.addClass('sidebar-animation');
    }

    if (typeof value === 'undefined') {
        value = !cinemaModeEnabled;
    }

    $videoLayer.toggleClass('__cinema', value);

    /* сinemaMode скрывает рекомендации (которые ограничены по высоте плеера) */
    $videoLayer.find('.recommendation-wrapper.__with-limit-height').toggleClass('__hide', value);

    function triggerScroll() {
        // VSRV-2527 [Videolayer]: Text area закрепляется внизу экрана отдельно от леера комментариев
        $scrollingContainer.trigger('scroll');
    }

    if (animation && redesign2023) {
        var video = $videoLayer[0].querySelector('.vp_video');
        var delta = video.getBoundingClientRect().top;

        scrollTo(scrollingContainer, {
            y: scrollingContainer.scrollTop + delta,
            duration: 250
        }).then(triggerScroll);
    } else {
        triggerScroll();
    }

    return value;
}

function scrollToComments(e) {
    var $element = $(this),
        id = $element.data('id'),
        type = $element.data('type');

    if (id && type) {
        import('OK/DiscussionManager').then(m => m && m.default || m).then(function(DiscussionManager) {
            DiscussionManager.forEachOpened(id, type, function() {
                this.form.focus();
            });
        });
    }

    e.preventDefault();
}

/**
 * Функция для активации леера просмотров
 */
function activatePopLayer() {
    var newBaseUrl = $('#video-poplayer-cnt').data('baseUrl');
    if (newBaseUrl) {
        baseUrl = newBaseUrl;
        baseUrlPrefix = newBaseUrl.substring(0, newBaseUrl.lastIndexOf('/') + 1);
    }
    pushNewUrl(baseUrl, true, 'popVideo');
}

function registerApi(_reactAPI) {
    reactAPI = _reactAPI;
}

export default { activate, deactivate, playMovie, navigateToMovie, playNextMovie, toggleCinemaMode, getNextMetadata, activatePopLayer, registerApi, BLOCK_ID };

export { activate, deactivate, playMovie, navigateToMovie, playNextMovie, toggleCinemaMode, getNextMetadata, activatePopLayer, registerApi, BLOCK_ID };
